import React, { useState } from "react";
import { Dialog, DialogContent, Divider } from "@mui/material";

const ReturnStatus = ({ status, items,title }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <p
        className="bg-blue-500 lg:cursor-pointer rounded-sm p-1 text-white"
        onClick={() => setOpen(true)}
      >
        Show Status
      </p>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{ className: "!m-0 lg:w-1/3  w-11/12" }}
      >
        <DialogContent className="!p-0">
          <p className="p-3 text-xl font-semibold">{title} Status</p>
          <Divider />
          <div className="flex flex-col">
            <p className="px-3 py-2">You are requested for {title} :</p>
            <Divider />
            <span className="flex gap-2 p-1">
              <img src={items?.product_images} alt="" className="w-20 h-20" />
              <span className="flex flex-col gap-1 ">
                <p>{items?.product_name}</p>
                <p className="text-sm">
                  Product Code :{" "}
                  <span className="text-red-500">{items?.item_code}</span>{" "}
                </p>
              </span>
            </span>
            <Divider />
            <span className="p-3 flex flex-col gap-1">
              <p>
                {title} Status :{" "}
                <span
                  className={
                    status?.return_status === "Pending"
                      ? "text-orange-500 font-bold"
                      : "font-bold text-green-500"
                  }
                >
                  {status?.return_status || status?.replacement_status}
                </span>
              </p>
              <p>
                Requested at Date :{" "}
                <span className="font-bold">
                  {status?.return_requested_date?.replace("T", ", Time : ") ||
                    status?.replacement_requested_date?.replace(
                      "T",
                      ", Time : "
                    )}
                </span>
              </p>
              <p className="!capitalize">
                Reasons :{" "}
                {status?.reason_for_return_choice ||
                  status?.reason_for_replacement_choice}
              </p>
            </span>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ReturnStatus;
